import React, { useEffect, useState } from "react";
import "./AdvDay.scss";
import { useNavigate, useParams } from "react-router-dom";
import Choices from "./Choice/Choices";
import EndOfDay from "./EndOfDay/EndOfDay";
import Navbar from "../../Navbar/Navbar";
import BurgerMenu from "../../BurgerMenu/BurgerMenu";
import { useMobile } from "../../../context/MobileContext";
import { IMAGE_BASE_URI } from "../../Constants";
import DiceCheck from "./DiceCheck/DiceCheck";
import SavedWidget from "./SavedWidget/SavedWidget";
import BigThrobber from "../../BigThrobber/BigThrobber";
import { isValidDate } from "../../../utils/date";
import CharacterSheet from "./CharacterSheet/CharacterSheet";
import Combat from "./Combat/Combat";

const AdvDayDemo: React.FC = () => {
  const navigate = useNavigate();
  const { day } = useParams();

  const [adventure, setAdventure] = useState(null);
  const { isMobile } = useMobile();

  const [savedDay, setSavedDay] = useState(null);
  const [loading, setLoading] = useState(true);
  const [last, setLast] = useState(1);
  const [shownParas, setShownParas] = useState([]);
  const [end, setEnd] = useState(false);
  const [hp, setHP] = useState(24);

  const doNothing = () => {};

  const incrementLast = () => {
    let next = last + 1;
    if (adventure?.paragraphs?.length && next > adventure.paragraphs.length) {
      setEnd(true);
      return;
    } else {
      while (adventure.paragraphs[next - 1].type === "text") {
        if (
          // adventure?.paragraphs?.length &&
          next >
          adventure?.paragraphs?.length - 1
        ) {
          setEnd(true);
          break;
        }
        next++;
      }
      console.log(next);
      setLast(next);
    }
  };

  useEffect(() => {
    if (loading) return;
    const shownParas = adventure?.paragraphs?.slice(0, last) || [];
    setShownParas(shownParas);
  }, [last, loading]);

  const mapParagraphs = (paragraph, index) => {
    switch (paragraph.type) {
      case "text":
        return (
          <p className="adventure-text" key={index}>
            {paragraph.text}
          </p>
        );
      case "diceCheck":
        return (
          <DiceCheck
            key={index}
            index={index}
            diceCheck={paragraph.diceCheck}
            result={null}
            setLast={incrementLast}
            savePara={doNothing}
            savedRoll={{ completed: false }}
          />
        );
      case "choices":
        return (
          <Choices
            key={index}
            index={index}
            choices={paragraph.choices}
            savedChoices={null}
            incrementLast={incrementLast}
            savePara={doNothing}
          />
        );
      case "combat":
        return (
          <Combat
            key={index}
            index={index}
            savePara={doNothing}
            combat={paragraph.combat}
            save={null}
            hp={hp}
            setHP={setHP}
            incrementLast={incrementLast}
          />
        );
      default:
        return <p key={index}>Unknown paragraph type</p>;
    }
  };

  useEffect(() => {
    //fecth adventure Data
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/adventure-demo/${parseInt(day)}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        ).catch((error) => {
          console.error("Error fetching data:", error);
          if (error.status === 403) navigate("/account");
          else navigate("/");
          return null;
        });
        const result = await response.json();
        if (result) {
          setAdventure(result.adventure);
          setLast(
            result.adventure.paragraphs.findIndex((p) => p.type != "text") + 1
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        navigate("/adventure");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [day]);

  return !loading && adventure && shownParas ? (
    <>
      {isMobile ? <Navbar /> : <BurgerMenu />}
      <CharacterSheet currentHp={hp} />
      <section
        className="full-page col-start daily-adventure"
        id="daily-adventure"
      >
        <div className="page col-start card">
          <div className="row-start adventure-header">
            <img src={`${IMAGE_BASE_URI}calendar-days/day_${day}.png`} alt="" />
            <div>
              <h2>Day {day}</h2>
              <h1>{adventure?.title}</h1>
            </div>
          </div>
          {shownParas.map(mapParagraphs)}
          {end && <EndOfDay day={parseInt(day)} />}
        </div>
      </section>
    </>
  ) : (
    <BigThrobber />
  );
};

export default AdvDayDemo;
